import { render, staticRenderFns } from "./ModalAtividades.vue?vue&type=template&id=5fbd7f8b&scoped=true&"
import script from "./ModalAtividades.vue?vue&type=script&lang=js&"
export * from "./ModalAtividades.vue?vue&type=script&lang=js&"
import style0 from "./ModalAtividades.vue?vue&type=style&index=0&id=5fbd7f8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd7f8b",
  null
  
)

export default component.exports